module.exports = __webpack_public_path__ + "static/img/torsoScaled44.bdfe66d0.png";